import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

type UseCompetitionLevelListQueryParams = Parameters<typeof SSF.api.competitionCategoriesList>[0];

const keys = createQueryKeySet<UseCompetitionLevelListQueryParams>('competition_levels');

export function useCompetitionLevelListQuery(params?: UseCompetitionLevelListQueryParams) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.competitionCategoriesList(params);
      return data;
    },
    queryKey: keys.list(params),
  });
}
